/* 孫吳傳・第 14 章：烏林延燒（建安十三年，208）
 * 史實：《三國志·周瑜傳》「頃之，煙炎張天，人馬燒溺死者甚衆，軍遂敗退，還保南郡。」
 *       《江表傳》（裴注）：「瑜等率輕銳尋繼其後，雷鼓大進，北軍大壞，曹公退走。」
 * 流程：操作周瑜，帶程普、黃蓋與輕銳從西側登上北岸。火被東南風吹著往北燒進烏林的營落：是武器，也是危險（站在火裡會被燒）。
 *       曹軍染了疫病，比較弱但人多。停下來擂鼓（讀條）全軍攻擊、移速上升一陣子。趕在曹操撤走前殺到本陣。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, TROOPS, rout, vanish } from '../kit.ts';
import { SHORE_N, CHAIN_Y, CHAIN } from '../maps/chibi.ts';

const LV = 12, START = [1500, 1250], HQ = [4600, 800], EXIT = [4300, 380], RETREAT_T = 150, DRUM_CD = 35;
const SICK = { spec: TROOPS.wei, name: '曹軍', hp: 380, maxHp: 380, atk: 20, ms: 210 };

export default {
  id: 'sunwu-14', map: 'chibi', hero: 'zhouyu',
  title: '第 12 章　烏林延燒', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '頃之，煙炎張天，人馬燒溺死者甚衆，軍遂敗退。', src: '《三國志·吳書·周瑜傳》' }],
    text: '火船撞進曹軍的船陣，火借風勢燒上北岸。周瑜率輕銳登岸，緊跟在火後頭推進。',
    goals: ['跟著火線推進，別走進火裡', '擂鼓大進', '趕在曹操撤走前殺到本陣'],
  },
  words: { ally: '輕銳', foe: '曹軍' },
  fuel(m, x, y) { return y < SHORE_N + 60 && !SG.MAP.waterAt(x, y) && SG.MAP.walkable(x, y, 0); },
  spreadMul() { return 0.22; }, // 岸上燒得比船陣慢：火線一點一點往北推
  stars: [
    { text: '程普、黃蓋都活著', ok: (m) => m.vars.cp.alive && m.vars.hg.alive },
    { text: '趕在曹操撤走前殺到本陣', ok: (m) => m.vars.hqT != null && m.vars.hqT < RETREAT_T },
    { text: '曹軍陣形大亂時擂鼓（身邊有 5 個以上敵人）', ok: (m) => !!m.vars.goodDrum },
  ],
  steps: [
    { // 1. 登岸推進
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        m.wind = [-0.25, -0.97];
        V.t0 = w.t; V.drumT = -99;
        V.cp = ally(w, 'chengpu', START[0] - 120, START[1] + 80, LV);
        V.hg = ally(w, 'huanggai', START[0] - 60, START[1] + 140, LV); V.hg.hp = V.hg.maxHp * 0.55;
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(START[0] - 200 - (i % 5) * 50, START[1] - 60 + Math.floor(i / 5) * 90, '輕銳'); m.join(u, me); return u; });
        // 火：船陣與江邊的營已經燒起來了
        for (let x = CHAIN[0] + 200; x <= CHAIN[1]; x += 80) { m.fire(x, CHAIN_Y, { dps: 45 }); if (x % 400 < 80) m.fire(x, SHORE_N - 20, { dps: 45 }); }
        // 曹軍：三座營裡都是染疫的兵；營外有些逃散的
        V.foes = [];
        for (const [cx, cy, n] of [[2500, 900, 12], [4600, 800, 16], [6800, 900, 12], [3500, 1150, 6], [5700, 1100, 6]]) for (let i = 0; i < n; i++) {
          const a = (i / n) * Math.PI * 2, u = m.foe('huangjin', cx + Math.cos(a) * 300, cy + Math.sin(a) * 200, SICK);
          w.addBuff(u, { id: '疫', t: 9999, neg: true, ms: -0.15, atkP: -0.2 }); V.foes.push(u);
        }
        V.cao = boss(w, hero('caocao'), HQ[0], HQ[1] - 60, { name: '曹操', hp: 5200, atk: 60, armor: 8, ms: 240, untargetable: true });
        V.guard = m.camp(HQ[0], HQ[1], [['bandit', 3]], 220).map((u) => Object.assign(u, { spec: TROOPS.wei, name: '虎豹騎' }));
        m.card('瑜等率輕銳尋繼其後。', '《江表傳》（裴注）');
        m.line('周瑜', '火勢已起！跟在火後頭，殺進烏林！');
        m.after(5, () => m.line('提示', '火會被風吹著往北燒，站在火裡也會被燒。停下來不動兩秒可以擂鼓：全軍一陣子攻擊、移速上升。'));
        m.mark('hq', HQ[0], HQ[1], '曹操本陣');
        m.obj('hq', '');
        m.obj('drum', '擂鼓大進（停下來兩秒）');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, left = RETREAT_T - (w.t - V.t0);
        m.get('hq').text = left > 0 ? `趕在曹操撤走前殺到本陣（還有 ${Math.ceil(left)} 秒）` : '曹操撤走了……殺到本陣';
        // 擂鼓：停下來兩秒；冷卻 35 秒
        const cd = V.drumT + DRUM_CD - w.t, o = m.get('drum');
        o.text = cd > 0 ? `擂鼓大進（${Math.ceil(cd)} 秒後可以再擂）` : '擂鼓大進（停下來兩秒）';
        if (cd <= 0) m.chanAt(me, 'drum', me.x, me.y, 9999, 2, '擂鼓', () => {
          V.drumT = w.t; o.done = true;
          const near = V.foes.filter((u) => u.alive && SG.gd(u.x, u.y, me.x, me.y) < 600).length;
          if (near >= 5) V.goodDrum = true;
          for (const u of w.units) if (u.alive && u.team === 0) w.addBuff(u, { id: '雷鼓', t: 12, atkP: 0.3, ms: 0.2 });
          m.big('雷鼓大進！'); w.fx({ k: 'boom', x: me.x, y: me.y, r: 300, col: '#e0b04a' });
        }, { hurt: false });
        if (left <= 0 && !V.gone) { V.gone = true; caoLeaves(m, w); }
        return m.near(me, HQ[0], HQ[1], 450);
      },
    },
    { // 2. 殺到本陣：北軍大壞，曹公退走
      enter(m, w) {
        const V = m.vars;
        V.hqT = w.t - V.t0;
        m.done('hq'); m.unmark('hq');
        if (!V.gone) { V.gone = true; caoLeaves(m, w); }
        m.card('雷鼓大進，北軍大壞，曹公退走。', '《江表傳》（裴注）');
        rout(m, w, V.foes.concat(V.guard), EXIT);
        m.after(6, () => m.card('軍遂敗退，還保南郡。', '《周瑜傳》'));
        m.after(11, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('周瑜陣亡'); return; }
    if (V.cp) { allyTick(w, V.cp, me); allyTick(w, V.hg, me); }
    // 曹軍看到火就往北逃，擠到本陣附近
    if (V.foes) { V.fleeT = (V.fleeT || 0) - 1 / 30; if (V.fleeT <= 0) { V.fleeT = 0.5; for (const u of V.foes) if (u.alive && !u.rout && m.burning(u.x, u.y + 60, 220)) { u.home = [u.x + (SG.rand() - 0.5) * 300, Math.max(450, u.y - 350)]; u.target = null; } } }
  },
};

function caoLeaves(m, w) {
  const c = m.vars.cao;
  m.line('曹操', '撤！往華容道走！');
  c.home = EXIT.slice(); c.ms = 260;
  m.after(6, () => vanish(w, c));
}
